export enum typeBannerHotel {
  BANNER = 'banner',
  HIGHLIGHT = 'highlight',
}
interface CreateAgregatorPublicityDto {
  image: string | File
  pluginSpaceAggregatorId: number | null
  externalLink: string
  order: number
  title: string
  type: typeBannerHotel
  startDate: string
  endDate: string
  status: boolean
}
interface UpdateAgregatorPublicityDto {
  image: string | File
  pluginSpaceAggregatorId: number | null
  externalLink: string
  order: number
  title: string
  type: typeBannerHotel
  startDate: string
  endDate: string
  status: boolean
}

interface AggregatorPublicity {
  id: number
  pluginspaceId: number
  image: string
  title: string
  type: typeBannerHotel
  order: number
  startDate: string
  endDate: string
  status: boolean
  description: string
  externalLink?: string
  createdAt: string
  updatedAt: string
}


export type { CreateAgregatorPublicityDto, AggregatorPublicity, UpdateAgregatorPublicityDto }